export default {
  label: {
    title: 'Integrações',
    description: 'Token de integração',
  },
};
